import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/home/SectionLabel";
import { PROBLEMS, BENEFITS } from "@/data/content";
import { X, Check } from "lucide-react";

export function DualList() {
    return (
        <section
            className="max-w-[1240px] mx-auto px-6 lg:px-10 py-20 lg:py-24"
            data-testid="dual-list-section"
        >
            <Reveal>
                <SectionLabel className="text-terracotta">Problem / Solution</SectionLabel>
                <h2 className="font-heading text-4xl sm:text-5xl tracking-tight text-ink mt-4 max-w-2xl">
                    The revenue leaks we plug — and what you get in return.
                </h2>
            </Reveal>

            <div className="mt-12 grid md:grid-cols-2 gap-6 lg:gap-8">
                <Reveal>
                    <div className="h-full rounded-2xl border border-linec bg-cream p-8 lg:p-10">
                        <h3 className="font-heading text-2xl text-ink">Problems we solve</h3>
                        <ul className="mt-7 space-y-4">
                            {PROBLEMS.map((p) => (
                                <li key={p} className="flex items-start gap-3">
                                    <span className="mt-0.5 w-6 h-6 rounded-full bg-rose-50 flex items-center justify-center shrink-0">
                                        <X size={13} className="text-rose-500" strokeWidth={2.6} />
                                    </span>
                                    <span className="text-sm lg:text-base text-inksoft leading-relaxed">
                                        {p}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </Reveal>

                <Reveal delay={0.1}>
                    <div className="h-full rounded-2xl border border-terracotta/20 bg-stone2/70 p-8 lg:p-10">
                        <h3 className="font-heading text-2xl text-ink">
                            What you get with DentAssists
                        </h3>
                        <ul className="mt-7 space-y-4">
                            {BENEFITS.map((b) => (
                                <li key={b} className="flex items-start gap-3">
                                    <span className="mt-0.5 w-6 h-6 rounded-full bg-terracotta/10 flex items-center justify-center shrink-0">
                                        <Check size={13} className="text-terracotta" strokeWidth={2.8} />
                                    </span>
                                    <span className="text-sm lg:text-base text-inksoft leading-relaxed">
                                        {b}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
